"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CRM_CALLING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CALLING;
  }
});
Object.defineProperty(exports, "CRM_CANNED_SNIPPETS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CANNED_SNIPPETS;
  }
});
Object.defineProperty(exports, "CRM_COMPANY_RECORDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_COMPANY_RECORDS;
  }
});
Object.defineProperty(exports, "CRM_CONTACT_ACTIVITY", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CONTACT_ACTIVITY;
  }
});
Object.defineProperty(exports, "CRM_CONTACT_COMPANY_INSIGHTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CONTACT_COMPANY_INSIGHTS;
  }
});
Object.defineProperty(exports, "CRM_CONTACT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CONTACT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CRM_CONVERSATIONAL_BOTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CONVERSATIONAL_BOTS;
  }
});
Object.defineProperty(exports, "CRM_CONVERSATIONS_INBOX", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_CONVERSATIONS_INBOX;
  }
});
Object.defineProperty(exports, "CRM_DEALS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_DEALS;
  }
});
Object.defineProperty(exports, "CRM_DOCUMENTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_DOCUMENTS;
  }
});
Object.defineProperty(exports, "CRM_EMAIL_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_EMAIL_SCHEDULING;
  }
});
Object.defineProperty(exports, "CRM_EMAIL_TEMPLATES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_EMAIL_TEMPLATES;
  }
});
Object.defineProperty(exports, "CRM_EMAIL_TRACKING_NOTIFICATIONS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_EMAIL_TRACKING_NOTIFICATIONS;
  }
});
Object.defineProperty(exports, "CRM_FACEBOOK_INSTAGRAM_LEAD_ADS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_FACEBOOK_INSTAGRAM_LEAD_ADS;
  }
});
Object.defineProperty(exports, "CRM_FORMS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_FORMS;
  }
});
Object.defineProperty(exports, "CRM_GMAIL_OUTLOOK_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_GMAIL_OUTLOOK_INTEGRATION;
  }
});
Object.defineProperty(exports, "CRM_LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_LIVE_CHAT;
  }
});
Object.defineProperty(exports, "CRM_MEETINGS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_MEETINGS;
  }
});
Object.defineProperty(exports, "CRM_PROSPECTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_PROSPECTS;
  }
});
Object.defineProperty(exports, "CRM_REPORTING_DASHBOARD", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_REPORTING_DASHBOARD;
  }
});
Object.defineProperty(exports, "CRM_TASKS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_TASKS;
  }
});
Object.defineProperty(exports, "CRM_TEAM_EMAIL", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_TEAM_EMAIL;
  }
});
Object.defineProperty(exports, "CRM_TICKETING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.CRM_TICKETING;
  }
});

var _HubSpotFeature = require("../HubSpotFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/hubspotFeatures/CRM.js
// module id = 721
// module chunks = 209 210 211 212